import React from 'react';
import { useDispatch } from 'react-redux';

import {
  Form
} from '@openedx/paragon';
import {
  FormattedMessage,
  injectIntl,
  intlShape,
} from '@edx/frontend-platform/i18n';

import * as widgetHooks from '../hooks';
import * as hooks from './hooks';
import messages from './messages';

import ErrorAlert from '../../../../../../sharedComponents/ErrorAlerts/ErrorAlert';
import ToggleItem from '../../../../../../../generic/configure-modal/ToggleItem';
import ConnectedVideoPreviewWidget from '../VideoPreviewWidget';
// import CollapsibleFormWidget from '../CollapsibleFormWidget';
/**
 * Collapsible Form widget controlling video source as well as fallback sources
 */
const VideoSourceWidget = ({
  // injected
  intl,
}) => {
  const dispatch = useDispatch();
  const {
    videoId,
    videoSource: source,
    fallbackVideos,
    allowVideoDownloads: allowDownload,
    preventSkipVideo
  } = widgetHooks.widgetValues({
    dispatch,
    fields: {
      [widgetHooks.selectorKeys.videoSource]: widgetHooks.genericWidget,
      [widgetHooks.selectorKeys.videoId]: widgetHooks.genericWidget,
      [widgetHooks.selectorKeys.fallbackVideos]: widgetHooks.arrayWidget,
      [widgetHooks.selectorKeys.allowVideoDownloads]: widgetHooks.genericWidget,
      [widgetHooks.selectorKeys.preventSkipVideo]: widgetHooks.genericWidget,
    },
  });
  const { videoIdChangeAlert } = hooks.videoIdChangeAlert();
  const { updateVideoId, updateVideoURL, updatePreventSkipVideo } = hooks.sourceHooks({
    dispatch,
    previousVideoId: videoId.formValue,
    setAlert: videoIdChangeAlert.set,
  });
  const {
    addFallbackVideo,
    deleteFallbackVideo,
  } = hooks.fallbackHooks({ fallbackVideos: fallbackVideos.formValue, dispatch });


  const handleRequiresVideoWatchChange = (e) => {
    // Dispatch action or call function to update the setting
    updatePreventSkipVideo(e);
  }

  return (
    <div>
      <ErrorAlert
        dismissError={videoIdChangeAlert.dismiss}
        hideHeading
        isError={videoIdChangeAlert.show}
      >
        <FormattedMessage {...messages.videoIdChangeAlert} />
      </ErrorAlert>

      <div className="">
        {/* <Form.Group>
          <Form.Control
            floatingLabel={intl.formatMessage(messages.videoIdLabel)}
            onChange={videoId.onChange}
            onBlur={updateVideoId}
            value={videoId.local}
            />
          <Form.Control.Feedback className="text-primary-300 mb-4">
            <FormattedMessage {...messages.videoIdFeedback} />
          </Form.Control.Feedback>
        </Form.Group> */}
        <Form.Group size="sm" className='mb-0'>
          <Form.Label className="text-secondory _font-weight-medium">Video URL</Form.Label>
          <Form.Control
            onChange={(e) => {
              source.onChange(e)
              updateVideoURL(e, videoId.local)
            }}
            onBlur={(e) => updateVideoURL(e, videoId.local)}
            value={source.local}
            style={{ height: '42px', borderRadius: '.75rem', border: '1px solid #0000001F' }}
            placeholder="Video URL"
          />
          {/* <Form.Control.Feedback className="text-primary-300">
            <FormattedMessage {...messages.videoUrlFeedback} />
          </Form.Control.Feedback> */}
        </Form.Group>
      </div>

      
    <ConnectedVideoPreviewWidget />

      <ToggleItem
        label={"Make this Video Un-skippable"}
        description={"Learners must watch the entire video before the unit can be marked as complete and this video cant be skipped."}
        checked={preventSkipVideo.local}
        onChange={handleRequiresVideoWatchChange}
        // borderless={true}
      ></ToggleItem>
      {/* <div className="mt-4">
        <FormattedMessage {...messages.fallbackVideoTitle} />
      </div>
      <div className="mt-3">
        <FormattedMessage {...messages.fallbackVideoMessage} />
      </div>
      {fallbackVideos.formValue.length > 0 ? fallbackVideos.formValue.map((videoUrl, index) => (
        <Form.Row className="mt-3.5 mx-0 flex-nowrap">
          <Form.Group>
            <Form.Control
              floatingLabel={intl.formatMessage(messages.fallbackVideoLabel)}
              onChange={fallbackVideos.onChange(index)}
              value={fallbackVideos.local[index]}
              onBlur={fallbackVideos.onBlur(index)}
            />
            <IconButtonWithTooltip
              key={`top-delete-${videoUrl}`}
              tooltipPlacement="top"
              tooltipContent={intl.formatMessage(messages.deleteFallbackVideo)}
              src={DeleteOutline}
              iconAs={Icon}
              alt={intl.formatMessage(messages.deleteFallbackVideo)}
              onClick={() => deleteFallbackVideo(videoUrl)}
            />
          </Form.Group>
        </Form.Row>
      )) : null}
      <ActionRow className="mt-4.5">
        <Form.Group>
          <Form.Checkbox
            checked={allowDownload.local}
            className="decorative-control-label"
            onChange={allowDownload.onCheckedChange}
          >
            <div className="small text-gray-700">
              <FormattedMessage {...messages.allowDownloadCheckboxLabel} />
            </div>
          </Form.Checkbox>
          <OverlayTrigger
            key="top"
            placement="top"
            overlay={(
              <Tooltip id="tooltip-top">
                <FormattedMessage {...messages.allowDownloadTooltipMessage} />
              </Tooltip>
            )}
          >
            <Icon src={InfoOutline} style={{ height: '16px', width: '16px' }} />
          </OverlayTrigger>
        </Form.Group>
        <ActionRow.Spacer />
      </ActionRow>

      <div className="my-4 border-primary-100 border-bottom" />
      <Button
        className="text-primary-500 font-weight-bold pl-0"
        size="sm"
        iconBefore={Add}
        variant="link"
        onClick={() => addFallbackVideo()}
      >
        <FormattedMessage {...messages.addButtonLabel} />
      </Button> */}
    </div>
  );
};
VideoSourceWidget.propTypes = {
  // injected
  intl: intlShape.isRequired,
};

export const VideoSourceWidgetInternal = VideoSourceWidget; // For testing only
export default injectIntl(VideoSourceWidget);
